import {
  InternalGenderComponent
} from 'app/modules/landing-publication/ext-profiles/types/internal-gender/internal-gender.component'
import {
  InternalBirthdateComponent
} from 'app/modules/landing-publication/ext-profiles/types/internal-birthdate/internal-birthdate.component'
import {
  EtatProvinceUsaCanadaComponent
} from 'app/modules/landing-publication/ext-profiles/types/etat-province-usa-canada/etat-province-usa-canada.component'
import {
  GenericUniqComponent
} from 'app/modules/landing-publication/ext-profiles/types/generic-uniq/generic-uniq.component'
import {
  GenericMultiComponent
} from 'app/modules/landing-publication/ext-profiles/types/generic-multi/generic-multi.component'
import {
  GenericTextboxComponent
} from 'app/modules/landing-publication/ext-profiles/types/generic-textbox/generic-textbox.component'

export const extProfileMapping = {
  internal_gender: InternalGenderComponent,
  internal_birthdate: InternalBirthdateComponent,
  etat_province_usa_canada: EtatProvinceUsaCanadaComponent
}

export const keyDefMapping = {
  SelectBt: GenericUniqComponent,
  SelectM: GenericMultiComponent,
  Text: GenericTextboxComponent
}
